'use strict';
var parent = require('../../stable/set');
require('../../modules/esnext.set.difference.v2');
require('../../modules/esnext.set.intersection.v2');
require('../../modules/esnext.set.is-disjoint-from.v2');
require('../../modules/esnext.set.is-subset-of.v2');
require('../../modules/esnext.set.is-superset-of.v2');
require('../../modules/esnext.set.symmetric-difference.v2');
require('../../modules/esnext.set.union.v2');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/actual/set/index.js
// module id = 1225
// module chunks = 0